import { components } from './tariff.schema'

export type TariffResponse = components['schemas']['tariffsResponse']

export interface getTariffParams {
  commercialProfile?: string
  customerType?: string
  subscriptionType?: string
  billingType?: string
  saleType?: string
  channel?: string
  dealer?: string
  commercialSegment?: string
}

export enum LineTypes {
  MAIN = 'mainLine',
  ADDITIONAL = 'additionalLine',
  ALL = 'all',
}
